import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import idx from 'idx';

import BaseLayout from '../common/layouts/BaseLayout';
import HeadShared from '../common/HeadShared';
import HomeHero from './hero';
import HomeFeature from './Feature';
import HomeContract from './contract';
import HomeHiw from './hiw';
import HomeSecurity from './security';
import HomeAboutUs from './aboutus';
import HomeReports from './reports';
import PartnerExchanges from '../landing/components/partner/PartnerExchanges';
import HomeFaq from './faq';
import HomeBottomCta from './cta';
import HomeStats from './stats';
import SimpleBanner from '../common/components/basic/SimpleBanner';

import { withTranslation, Trans, useTranslation } from '../common/libs/i18n';

import useTheme from '../common/utils/styles/theme/useTheme';
import { Container } from '../common/base';
import View from '../common/components/basic/View';
import getReadibilityColor from '../common/utils/styles/utils/readibility';

function Seperator() {
  const { colors } = useTheme();
  return (
    <div
      css={css`
        width: 100%;
        height: 2px;
        background-color: ${colors.gray.stain};
      `}
    />
  );
}

function GrayBackground({ children, className }) {
  const { colors } = useTheme();
  return (
    <div
      className={className}
      css={`
        background-color: ${colors.gray.light};
        color: ${({ theme }) => getReadibilityColor(theme.colors.gray.primary, theme)};
        overflow: auto;
      `}
    >
      {children}
    </div>
  );
}

GrayBackground.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

function Section({ children }) {
  return (
    <View
      css={css`
        margin: 100px;
      `}
    >
      {children}
    </View>
  );
}

Section.propTypes = {
  children: PropTypes.node
};

const Landing = () => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <SimpleBanner
        url={t(
          'landing.banner.top.url',
          'https://medium.com/rupiahtoken-blog/rupiah-token-issuing-idrtb-stablecoin-on-binance-chain-db5ee1ae3beb'
        )}
      >
        <Trans i18nKey="landing.banner.top.content">
          Rupiah Token is now also on Binance Chain!
{' '}
          <span role="img" aria-label="celebration">
            🎉🎉
          </span>
        </Trans>
      </SimpleBanner>
      <BaseLayout>
        <HeadShared
          title={`RupiahToken - ${t(
            'introduction.title',
            'The First Stablecoin Backed By Rupiah'
          )}`}
          desc={t(
            'introduction.subtitle',
            'Rupiah Token (IDRT) is a crypto asset on the Ethereum Blockchain that gives you access to global crypto exchanges. You can always redeem 1 IDRT for Rp 1, giving it a stable price.'
          )}
        />
        <HomeHero />
        <div
          css={`
            padding: 100px 0;
            overflow: auto;
            background-image: linear-gradient(180deg, ${colors.gray.primary}, ${colors.gray.light});
            color: ${({ theme }) => getReadibilityColor(theme.colors.gray.primary, theme)};
          `}
        >
          <Container>
            <PartnerExchanges />
          </Container>
        </div>
        <div
          css={`
            overflow: auto;
            background: ${colors.gray.light};
            color: ${({ theme }) => getReadibilityColor(theme.colors.gray.light, theme)};
          `}
        >
          <Container>
            <Seperator />
          </Container>
          <HomeFeature />
        </div>
        {/* <HomeContract /> */}
        <HomeStats />
        <HomeAboutUs />
        <HomeHiw />
        <GrayBackground>
          <HomeSecurity />
          <View
            css={`
              margin: 100px;
            `}
          >
            <Seperator />
          </View>
          <HomeFaq />
        </GrayBackground>
        <HomeReports />
        <HomeBottomCta />
      </BaseLayout>
    </React.Fragment>
  );
};

export default withTranslation('common')(Landing);
